import { Colors, Icon } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Box } from 'ui-components'
import React from 'react'

import { TaskCellProps } from './task-cell'

const MenuTaskCell = ({ task }: TaskCellProps) => {
  return (
    <Box>
      {task._raw.tags?.includes('MENU_TASK') && (
        <Tooltip2 minimal content={'Menu task'}>
          <Icon style={{ color: Colors.TURQUOISE5 }} icon="list-detail-view" />
        </Tooltip2>
      )}
    </Box>
  )
}
export default MenuTaskCell
